import axios from "axios";
import Config from "../config";
import RefreshTokenHandler from "../refreshToken/refreshToken";

export const getClinicByCode = async (
  email,
  clinic_code,
  distributor_code = ""
) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/clinic/by-code?email=${email}&clinic_code=${clinic_code}&distributor_code=${distributor_code}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getClinicByCode(email, clinic_code, distributor_code);
      } else {
        return err.response;
      }
    } else {
      return err.response;
    }
  }
};
